import { buildFolderTree } from './folderTree'
import type { FolderOption } from './folderTree'

/** Partition once for both table rows and cards. Counts include descendants. */
export function groupFolderRows<Row>(
  folders: readonly FolderOption[],
  rows: readonly Row[],
  folderIdOf: (row: Row) => string | undefined,
) {
  const tree = buildFolderTree(folders)
  const rowsByFolder = new Map<string, Row[]>()
  const counts = new Map<string, number>()
  const unmatched: Row[] = []
  for (const row of rows) {
    const id = folderIdOf(row)
    const node = id === undefined ? undefined : tree.byId.get(id)
    if (!node) { unmatched.push(row); continue }
    const ownRows = rowsByFolder.get(node.value) ?? []
    ownRows.push(row)
    rowsByFolder.set(node.value, ownRows)
    for (const part of node.path) counts.set(part.value, (counts.get(part.value) ?? 0) + 1)
  }
  return { ...tree, rowsByFolder, counts, unmatched }
}
